import { AfterViewInit, Component, OnInit, ViewChild } from '@angular/core';
import { IonRouterOutlet, Platform } from '@ionic/angular';
import { SplashScreen } from '@ionic-native/splash-screen/ngx';
import { StatusBar } from '@ionic-native/status-bar/ngx';
import { PaymentService } from './core/services/payment.service';
import { StorageService } from './core/services/storage.service';
import { BASE_URL_PATH, STONE_CREEK_MERCHANT_ID, STORAGE_CUSTOMER_DATA } from './core/constants';
import { Router, NavigationEnd } from '@angular/router';
import { merchantConfig } from '../environments/merchant-config';
import { filter } from 'rxjs/operators';
import { Customer } from './core/models/customer.model';
import { SwipeGestureService } from './core/services/swipe-gesture.service';
import { RouteService } from './core/services/route.service';
import { Location } from '@angular/common';
import { UtilService } from './core/services/util.service';
import { Platforms } from './core/enums/util.enum';
import { SquarePayService } from './core/services/square-pay-service.service';

declare const codePush: any;

@Component({
  selector: 'app-root',
  templateUrl: 'app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent implements OnInit, AfterViewInit {
  @ViewChild(IonRouterOutlet, { static: false }) routerOutlet: IonRouterOutlet;

  constructor(
    private platform: Platform,
    private splashScreen: SplashScreen,
    private statusBar: StatusBar,
    private router: Router,
    private paymentService: PaymentService,
    private storageService: StorageService,
    private swipeGestureService: SwipeGestureService,
    private routeService: RouteService,
    private location: Location,
    public utilService: UtilService,
    private squarePayService: SquarePayService
  ) {
    this.initializeApp();
  }

  private initializeApp(): void {
    this.platform.ready().then(() => {
      if (this.platform.is(Platforms.CORDOVA)) {
        this.initializeStatusBar();
        this.listenRouteChanges();
        this.splashScreen.hide();
        this.squarePayService.checkCanUseWalletPay();
        this.initializeHotPush();
      }
    });
  }

  private initializeStatusBar(): void {
    this.statusBar.show();
    if (this.platform.is(Platforms.ANDROID)) {
      this.statusBar.overlaysWebView(false);
    } else {
      this.statusBar.overlaysWebView(true);
    }
  }

  private listenRouteChanges(): void {
    if (this.platform.is(Platforms.IOS)) {
      this.router.events.subscribe((event) => {
        if (event instanceof NavigationEnd) {
          this.location.path().includes('home-screen') ? this.statusBar.styleDefault() : this.statusBar.styleLightContent();
        }
      });
    }
  }

  ngOnInit() {
    this.routeService.checkParams();
    if (this.platform.is(Platforms.CORDOVA)) {
      this.setMerchantIfNotExists();
    }
    this.updateCustomerPlatform();
  }

  ngAfterViewInit() {
    this.swipeGestureService.init(this.routerOutlet);
  }

  private initializeHotPush(): void {
    codePush.sync();
    codePush.getCurrentPackage((update: any) => {
      if (update && update.description) {
        this.storageService.set('merchantId', update.description);
      }
    });
  }

  private async updateCustomerPlatform(): Promise<void> {
    const data = await this.storageService.get(STORAGE_CUSTOMER_DATA);
    if (!data || !data.phone) {
      return;
    }
    if (this.platform.is(Platforms.CORDOVA)) {
      this.paymentService
        .getCustomerByPhone(data.phone, false, false)
        .pipe(filter(Boolean))
        .subscribe((customer: Customer) => {
          this.paymentService.updateCustomerPlatform(customer.squareCustomerId).subscribe();
        });
    }
  }

  private loadStartCordovaPage(merchantId: string): void {
    const routeUrls = [BASE_URL_PATH];
    if (merchantId) {
      routeUrls.push(merchantId);
    }
    if (merchantConfig.id === STONE_CREEK_MERCHANT_ID) {
      this.router.navigate([BASE_URL_PATH, STONE_CREEK_MERCHANT_ID, 'home-screen']);
    }
  }

  private async setMerchantIfNotExists(): Promise<void> {
    const merchantId = await this.storageService.get('merchantId');
    if (merchantId) {
      this.loadStartCordovaPage(merchantId);
    } else {
      this.storageService.set('merchantId', merchantConfig.id);
      this.loadStartCordovaPage(merchantConfig.id);
    }
  }
}
